import Fullscreen from '@/js/core/Fullscreen'

export default class VideoPlayer extends Fullscreen {
  selectors = {
    'video': '[data-video]',
  }

  playVideo () {
    const { video } = this.$els
    video.currentTime = 0
    video.play()
  }

  pauseVideo () {
    const { video } = this.$els
    if (!video.paused) {
      video.pause()
    }
  }
}